module.exports = __webpack_public_path__ + "img/TZS09622.0c1f16c7.jpeg";